import React, { useState } from "react";
import { Link } from "react-router-dom";

import TopStrip from "../components/TopStrip";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";

import heroBanner from "../assets/images/hero-images/manages services.webp";
import heroMobile from "../assets/images/mobile-banners/managed-services-mobile.webp";
import downloadGif from "../assets/images/managed-services/download-animation.gif";
import servicePdf from "../assets/pdfs/DDevOps-Company-Service-updated_250513_175749.pdf";

import phpTab from "../assets/images/tab-images/php1.webp";
import meanTab from "../assets/images/tab-images/2.webp";
import javaTab from "../assets/images/tab-images/3.webp";
import pythonTab from "../assets/images/tab-images/4.webp";

function ManagedServices() {
  const [activeTab, setActiveTab] = useState("php");

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* HERO */}
      <section style={{ marginTop: "125px" }}>
        <div className="container-fluid p-0">
          <img
            src={heroBanner}
            width="1600"
            height="520"
            alt="Managed IT and hosting banner with server network graphics and 24/7 support tagline."
            className="img-fluid w-100 d-none d-md-block"
          />
          <img
            src={heroMobile}
            width="768"
            height="1000"
            alt="Managed IT and hosting banner with server network graphics and 24/7 support tagline."
            className="img-fluid w-100 d-md-none d-block"
          />
        </div>
      </section>

      {/* EXPERIENCE & EVOLUTION SECTION */}
      <section className="experience-section">
        <div className="container">
          <div className="row align-items-center gy-4">
            {/* Left */}
            <div className="col-lg-4 text-center text-lg-start">
              <div className="experience-card d-flex align-items-center gap-3">
                <div className="experience-number">50+</div>
                <div className="experience-text-lines">
                  <span>Years</span>
                  <span>Of</span>
                  <span>IT Services</span>
                </div>
              </div>
              <div className="experience-evolution text-center text-lg-start mt-3">
                Evolved into <span>Managed Operations</span>
              </div>
            </div>

            {/* Right */}
            <div className="col-lg-8">
              <div className="experience-content">
                <h3>Turning Infrastructure into a Competitive Advantage</h3>
                <p>
                  Managed Services transforms your infrastructure from a basic
                  utility into a strategic asset. We deliver a unified ecosystem
                  where hosting, system administration, and IT operations work
                  together seamlessly.
                </p>
                <p className="mb-0">
                  From proactive OS patching to complex migrations, our
                  dedicated operations team ensures your servers are
                  continuously optimized, secured, and performing at peak
                  efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATISTICS SECTION */}
      <section className="bg-info-subtle py-3 my-5" data-aos="fade-left">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 mb-4 mb-md-0 position-relative">
              <h2 className="fw-bold text-info display-5 mb-0">99.9%</h2>
              <p className="text-uppercase mt-2 fw-semibold">
                UPTIME DELIVERED
              </p>
              <div
                className="d-none d-md-block position-absolute top-0 end-0 h-100"
                style={{ width: "1px", backgroundColor: "gray" }}
              ></div>
            </div>
            <div className="col-md-3 mb-4 mb-md-0 position-relative">
              <h2 className="fw-bold text-info display-5 mb-0">500+</h2>
              <p className="text-uppercase mt-2 fw-semibold">SERVERS MANAGED</p>
              <div
                className="d-none d-md-block position-absolute top-0 end-0 h-100"
                style={{ width: "1px", backgroundColor: "gray" }}
              ></div>
            </div>
            <div className="col-md-3 mb-4 mb-md-0 position-relative">
              <h2 className="fw-bold text-info display-5 mb-0">24/7</h2>
              <p className="text-uppercase mt-2 fw-semibold">EXPERT SUPPORT</p>
              <div
                className="d-none d-md-block position-absolute top-0 end-0 h-100"
                style={{ width: "1px", backgroundColor: "gray" }}
              ></div>
            </div>
            <div className="col-md-3">
              <h2 className="fw-bold text-info display-5 mb-0">15+</h2>
              <p className="text-uppercase mt-2 fw-semibold">
                CERTIFIED ADMINS
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CORE MANAGED PILLARS */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold display-6">Our Core Managed Pillars</h2>
            <p className="text-muted fs-5">
              Three pillars that power secure, fast, and reliable IT operations
            </p>
          </div>
          <div className="row g-4">
            {/* Pillar 1 */}
            <div className="col-lg-4 col-md-6">
              <div className="pillar-card h-100">
                <h4 className="fw-bold mb-2">Proactive Server Management</h4>
                <p className="text-muted fst-italic">
                  The Engine Room — We take full responsibility for your OS
                  health.
                </p>
                <ul className="pillar-list">
                  <li>OS Patching & Hardening (Linux & Windows)</li>
                  <li>24/7 CPU, RAM & Disk Monitoring</li>
                  <li>Crash Prevention & Performance Alerts</li>
                  <li>Disaster Recovery & Automated Backups</li>
                </ul>
              </div>
            </div>

            {/* Pillar 2 */}
            <div className="col-lg-4 col-md-6">
              <div className="pillar-card h-100 featured">
                <h4 className="fw-bold mb-2">
                  High-Performance Managed Hosting
                </h4>
                <p className="text-muted fst-italic">
                  The Foundation — Infrastructure built for speed, not just
                  storage.
                </p>
                <ul className="pillar-list">
                  <li>Free Zero-Downtime Migration</li>
                  <li>Dedicated CPU & RAM Resources</li>
                  <li>No Noisy Neighbors</li>
                  <li>Free SSL & Basic DDoS Protection</li>
                </ul>
              </div>
            </div>

            {/* Pillar 3 */}
            <div className="col-lg-4 col-md-6">
              <div className="pillar-card h-100">
                <h4 className="fw-bold mb-2">Dedicated IT Operations Team</h4>
                <p className="text-muted fst-italic">
                  The Support — Your in-house IT team at a fraction of the cost.
                </p>
                <ul className="pillar-list">
                  <li>Software Installation & Maintenance</li>
                  <li>Email, DNS, SPF, DKIM & DMARC Management</li>
                  <li>Corporate Email Troubleshooting</li>
                  <li>Senior Engineer Technical Consultation</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TABS SECTION */}
      <section id="tab-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <h1 className="text-center top-line mt-5">
                Curated <span className="text-info">High-Performance</span>{" "}
                Stacks.
              </h1>
              <p className="text-center">
                We have benchmarked every combination. Whether you run PHP,
                Python, or Java, we deploy the exact caching and acceleration
                layer your code needs to fly.
              </p>
            </div>
          </div>
        </div>

        <div className="container w-75 my-5 custom-tab-container">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "php" ? "active" : ""}`}
                onClick={() => setActiveTab("php")}
                type="button"
              >
                PHP / Laravel (The Speed Layer)
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "mean" ? "active" : ""}`}
                onClick={() => setActiveTab("mean")}
                type="button"
              >
                Mean / Mern (The Async Layer)
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "java" ? "active" : ""}`}
                onClick={() => setActiveTab("java")}
                type="button"
              >
                Java / Spring (The Enterprise Layer)
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "python" ? "active" : ""}`}
                onClick={() => setActiveTab("python")}
                type="button"
              >
                Python (Django / Flask)
              </button>
            </li>
          </ul>

          <div className="tab-content p-3 border-top-0">
            {/* PHP */}
            <div
              className={`tab-pane fade ${activeTab === "php" ? "show active" : ""}`}
            >
              <div className="row align-items-center">
                <div className="col-lg-6 col-sm-12">
                  <p className="text-start" style={{ fontSize: "1rem" }}>
                    <strong>The 100ms Benchmark</strong> We don't just install
                    Apache. We layer Nginx as a reverse proxy, Varnish for HTTP
                    caching, and Redis for object caching. The result? PHP
                    applications that handle 10x the traffic of a standard LAMP
                    stack.
                  </p>
                </div>
                <div className="col-lg-6 col-sm-12 text-center">
                  <img
                    src={phpTab}
                    loading="lazy"
                    alt="PHP Stack"
                    className="img-fluid"
                    style={{ maxWidth: "140%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            {/* MEAN */}
            <div
              className={`tab-pane fade ${activeTab === "mean" ? "show active" : ""}`}
            >
              <div className="row align-items-center">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <p className="text-start" style={{ fontSize: "1rem" }}>
                    <strong>Node.js at Scale</strong> Specialized PM2 process
                    management and Nginx load balancing ensure your
                    single-threaded event loop never gets blocked, even under
                    massive concurrency.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={meanTab}
                    loading="lazy"
                    alt="MEAN Stack"
                    className="img-fluid"
                    style={{ maxWidth: "140%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            {/* JAVA */}
            <div
              className={`tab-pane fade ${activeTab === "java" ? "show active" : ""}`}
            >
              <div className="row align-items-center">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <p className="text-start" style={{ fontSize: "1rem" }}>
                    <strong>JVM Optimization</strong> Custom Heap memory tuning
                    and Garbage Collection strategies tailored to your
                    application's footprint, ensuring stability for long-running
                    enterprise processes.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={javaTab}
                    loading="lazy"
                    alt="Java Stack"
                    className="img-fluid"
                    style={{ maxWidth: "140%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            {/* PYTHON */}
            <div
              className={`tab-pane fade ${activeTab === "python" ? "show active" : ""}`}
            >
              <div className="row align-items-center">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <p className="text-start" style={{ fontSize: "1rem" }}>
                    We fix <b>Python's concurrency</b> limits using optimized
                    uWSGI/Gunicorn setups with Nginx. Celery offloads intensive
                    tasks for smooth, non‑blocking performance. With tuned
                    PostgreSQL, your Django or Flask app scales effortlessly
                    under heavy traffic.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={pythonTab}
                    loading="lazy"
                    alt="Python Stack"
                    className="img-fluid"
                    style={{ maxWidth: "140%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MANAGED SERVICE PACKAGES */}
      <section className="managed-packages py-5" id="services-pkg">
        <div className="container">
          <div className="row align-items-center gy-5">
            {/* Left Content */}
            <div className="col-lg-4">
              <span className="section-tag">Pricing</span>
              <h2 className="fw-bold mb-3">Managed Service Packages</h2>
              <p className="text-muted mb-4">
                Flexible service tiers designed to support everything from small
                websites to mission-critical enterprise applications.
              </p>
              <a href="#!" className="btn btn-primary px-4 py-2">
                Compare Plans
              </a>
            </div>

            {/* Right Pricing */}
            <div className="col-lg-8">
              <div className="row g-4">
                {/* Standard */}
                <div className="col-md-4">
                  <div className="pricing-card">
                    <h5 className="fw-bold">Standard</h5>
                    <p className="plan-subtitle">Maintenance</p>
                    <div className="price">
                      $10<span>/mo</span>
                    </div>
                    <ul>
                      <li>
                        <strong>Best For:</strong> Blogs & Static Sites
                      </li>
                      <li>
                        <strong>Engine:</strong> Standard Tuning
                      </li>
                      <li>
                        <strong>Response:</strong> 30 Minutes
                      </li>
                      <li>
                        <strong>OS Patching:</strong> Monthly
                      </li>
                      <li>
                        <strong>Monitoring:</strong> Uptime Only
                      </li>
                      <li>
                        <strong>Backups:</strong> Daily
                      </li>
                      <li>
                        <strong>Support:</strong> Ticket Support
                      </li>
                    </ul>
                    <Link
                      to="/contact"
                      className="btn btn-outline-primary w-100"
                    >
                      Subscribe
                    </Link>
                  </div>
                </div>

                {/* Professional */}
                <div className="col-md-4">
                  <div className="pricing-card featured">
                    <h5 className="fw-bold">Professional</h5>
                    <p className="plan-subtitle">Management</p>
                    <div className="price">
                      $30<span>/mo</span>
                    </div>
                    <ul>
                      <li>
                        <strong>Best For:</strong> SMBs & E-Commerce
                      </li>
                      <li>
                        <strong>Engine:</strong> Advanced Caching
                      </li>
                      <li>
                        <strong>Response:</strong> 30 Minutes
                      </li>
                      <li>
                        <strong>OS Patching:</strong> Weekly
                      </li>
                      <li>
                        <strong>Monitoring:</strong> CPU / RAM
                      </li>
                      <li>
                        <strong>Backups:</strong> Weekly / Monthly
                      </li>
                      <li>
                        <strong>Support:</strong> Ticket & Chat
                      </li>
                    </ul>
                    <Link to="/contact" className="btn btn-primary w-100">
                      Subscribe
                    </Link>
                  </div>
                </div>

                {/* Enterprise */}
                <div className="col-md-4">
                  <div className="pricing-card">
                    <h5 className="fw-bold">Enterprise</h5>
                    <p className="plan-subtitle">Dedicated</p>
                    <div className="price">
                      $50<span>/mo</span>
                    </div>
                    <ul>
                      <li>
                        <strong>Best For:</strong> Mission-Critical Apps
                      </li>
                      <li>
                        <strong>Engine:</strong> Custom Architecture
                      </li>
                      <li>
                        <strong>Response:</strong> 30 Minutes
                      </li>
                      <li>
                        <strong>OS Patching:</strong> As Released
                      </li>
                      <li>
                        <strong>Monitoring:</strong> Deep App Monitoring
                      </li>
                      <li>
                        <strong>Backups:</strong> Real-Time / Hourly
                      </li>
                      <li>
                        <strong>Support:</strong> Slack / Phone + Priority
                      </li>
                    </ul>
                    <Link
                      to="/contact"
                      className="btn btn-outline-primary w-100"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FLEXIBLE HOSTING OPTIONS CTA */}
      <section className="hosting-cta-section">
        <div className="container">
          <div className="row align-items-center gy-4">
            {/* Left Content */}
            <div className="col-lg-6">
              <span className="section-label">Flexible Hosting Options</span>
              <h2
                className="cta-headline"
                style={{ textTransform: "capitalize" }}
              >
                Still looking for a more affordable managed server?
              </h2>
              <p className="cta-punchline">
                <strong className="wait-text">WAIT.</strong> We have got
                everything from Managed Shared Hosting to Cloud Servers and VPS.
              </p>
              <p className="cta-description">
                You don't have to overpay for performance. We have a solution
                designed for every budget — without compromising speed or
                reliability.
              </p>
              <p className="cta-link-text">
                Get a complete <strong>LIST</strong> of all available packages
              </p>
              <a
                href={servicePdf}
                target="_blank"
                rel="noreferrer"
                className="btn btn-info cta-btn"
              >
                Download Price List (0.5MB)
              </a>
            </div>

            {/* Right Visual */}
            <div className="col-lg-6 text-center">
              <div className="cta-visual-wrapper">
                <img
                  src={downloadGif}
                  alt="Hosting Price List"
                  width="550"
                  className="img-fluid cta-visual"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default ManagedServices;
